<template>
	<b-row>
		<b-col cols="12">
			<b-card>
				<div slot="header">
					{{this.$t('prices.radioButtons.pricingDocs')}}
				</div>
				<b-table class="generalTableClass" hover="hover" striped="striped"
						 :items="items" :fields="columns" show-empty>
					<template slot="empty" slot-scope="scope">
						<h4>{{ $t('empty') }}</h4>
					</template>
					<template slot="actions" slot-scope="data">
						<b-link :key="data.item.id"
								@click="openModalTransfer(data.item)"
						>
							<i class="fa fa-tasks"></i>
						</b-link>
					</template>
				</b-table>
				<nav>
					<b-pagination :total-rows="totalCount" :per-page="searchForm.limit" v-model="searchForm.page"
								  :prev-text="$t('pagination.prev')"
								  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
				</nav>

			</b-card>
		</b-col>
		<b-modal
			v-model="modalTransfer"
			size="xl"
			:title="$t('sidebar.warehouse-management.transfers')"
			hide-footer>


			<div>
				<h4> {{ $t('incomes.name') }} :  <span class="text-danger text-center">{{currentDocument.regNumber }}</span></h4>
				<br />
				<div class="generalTableClass table-responsive-true">
					<b-table
						:items="documentItems"
						:fields="fields"
						hover="hover"
						striped="striped"
						bordered="bordered"
					>
						<!-- EMPTY SLOT FOR TABLE -->
						<template slot="empty" slot-scope="scope">
							<h4>{{ $t('empty') }}</h4>
						</template>
						<template slot="id" slot-scope="data">
							{{ data.index + 1 }}
						</template>

						<!-- EMPTY SLOT FOR TABLE -->
						<template slot="artikul" slot-scope="data">
							{{ data.item.artikul }}
						</template>
						<template slot="color" slot-scope="data">
							{{ data.item.color }}
						</template>
						<template slot="size" slot-scope="data">
							{{ data.item.size }}
						</template>
						<template slot="realBalance" slot-scope="data">
							{{ data.item.realBalance>0?data.item.realBalance:0 }}
						</template>
						<template slot="sectorId" slot-scope="data">
							<span>{{ setSector(data.item.sectorId) }}</span>
						</template>
						<template slot="itemName" slot-scope="data">
							<span v-if="data.item.wrapped"><strong>Упаковка - </strong>{{ data.value ? data.value.substring(0, 30) : '-' }}</span>
							<span v-else>{{ data.value ? data.value.substring(0, 30) : '-' }}</span>
						</template>
						<template slot="count" slot-scope="data">
							<b-form-input :ref="data.index + '1'" type="text"
										  v-model.number="data.item.count" class="move">
							</b-form-input>
						</template>
						<template slot="incomeUsd" slot-scope="data">
							<div class="inputWidth"> {{data.item.incomingPriceUsd ? data.item.incomingPriceUsd : 0 |
								currency({
								symbol: userDepCurrencyName, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}
							</div>
						</template>
						<template slot="check" slot-scope="data">
							<b-checkbox v-model="data.item.checked"></b-checkbox>
						</template>



						<template slot="priceUsd" slot-scope="data">
							{{ data.value * data.item.count }}$ (USD)
						</template>
						<template slot="itemIncomeTotal" slot-scope="data">
							{{ data.item.incomingPriceUsd * data.item.count | currency({
							symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							}) }}
						</template>
					</b-table>
				</div>
				<hr>
				<div class="row">
					<b-col cols="12">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
						:label="$t('incomes.create.to-warehouse')"
						label-for="refName"
						class="required ml-1"
						size="sm"
					>
						<template slot="label">
							{{ $t('incomeFilter.department')}} <span class="text-danger">*</span>
						</template>
						<b-form-select
							size="sm"
							name="toDepartmentId"
							v-model="toDepartmentId"
						>
							<option v-for="(selectOption, indexOpt) in toDepartments"
									:key="indexOpt"
									:value="selectOption.value"
									:disabled=" !selectOption.saleType || currentDocument.toDepartmentId === selectOption.value"
									:style="!selectOption.saleType ? 'color:red' : ''"
							>
								{{ selectOption.text }} {{ !selectOption.saleType ? ' &nbsp;&nbsp;('+$t('sale_type_undefined')+')'
								: '' }}
							</option>
							<template slot="first">
								<option :value="null" disabled>-- {{ $t('incomeFilter.department') }} --</option>
							</template>
						</b-form-select>

					</b-form-group>
					</b-col>
				</div>
				<div class="row">
					<b-col cols="12">
						<b-form-group
							breakpoint="lg"
							label-size="sm"
							label-cols="4"
							:label="$t('incomes.create.to-warehouse')"
							label-for="refName"
							class="required ml-1"
							size="sm"
						>
							<template slot="label">
								{{ $t('incomes.create.reason') }} <span class="text-danger">*</span>
							</template>

							<b-form-textarea
								v-model="reason"
								:placeholder="$t('incomes.create.reason')"
							></b-form-textarea>

						</b-form-group>
					</b-col>


				</div>
				<div class="row top mt-3 justify-content-end">
					<div class="col-4">
						<b-button variant="outline-danger" size="sm" block :disabled="loading"
								  @click="closeModal">
							{{$t('actions.cancel')}}
						</b-button>
					</div>
					<div class="col-4">
						<b-button variant="outline-success" size="sm" block @click="save" :disabled="loading">
							{{$t('actions.save')}}
						</b-button>
					</div>
				</div>
			</div>
		</b-modal>
	</b-row>

</template>

<script>
	import UsersService from "../../../services/users.sevice";
	import WhDocument from "../../../services/wh-document.service";
	import {mapState} from 'vuex'

	export default {
		name: 'TransferByDocument',
		data() {
			return {
				totalCount: 0,
				modalTransfer: false,
				searchForm: {
					limit: 1,
					page: 20
				},
				loading:false,
				reason:'',
				items: [],
				toDepartments: [],
				toDepartmentId: null,
				currentDocument: {},
				columns: [
					{
						key: 'id',
						label: '№',
						visible: true,
						'class': 'min-60',
						changebale: false
					},
					{
						key: 'regDate',
						label: this.$t('incomes.date'),
						visible: true,
						'class': 'min-80',
						changebale: true
					},
					{
						key: 'regNumber',
						label: this.$t('incomes.name'),
						visible: true,
						'class': 'min-200',
						changebale: true
					},
					{
						key: 'toDepartmentName',
						label: this.$t('incomes.toDepartment'),
						class: 'min-150',
						visible: true,
						changebale: true
					},
					{
						key: 'reason',
						label: this.$t('incomes.reason'),
						visible: true,
						'class': 'min-200',
						changebale: true
					},
					{
						key: 'comment',
						label: this.$t('comment'),
						'class': 'min-200',
						visible: true,
						changebale: true
					},

					{
						key: 'actions',
						label: this.$t('incomes.actions'),
						'class': 'table_actions',
						visible: true,
						changebale: false
					}

				],
				documentItems:[],
				fields: [
					{
						key: 'check',
						label: '',
					},
					{
						key: 'id',
						label: '№',
					},
					{
						key: 'artikul',
						label: this.$t('goods.artikul'),
						'class': 'incomeItemArtikul',
						visible: true,
						changebale: true
					},
					{
						key: 'color',
						label: this.$t('goods.color'),
						'class': 'incomeItemArtikul',
						visible: true,
						changebale: true
					},
					{
						key: 'size',
						label: this.$t('goods.size'),
						'class': 'incomeItemSize',
						visible: true,
						changebale: true
					},
					{
						key: 'itemName',
						label: this.$t('incomes.create.product'),
						'class': 'not-first',
						visible: true,
						changebale: true
					},
					{
						key: 'count',
						label: this.$t('incomes.create.count'),
						'class': 'td-30',
						visible: true,
						changebale: true
					},

					{
						key: 'incomeUsd',
						label: this.$t('prices.item.sum'),
					},
					{
						key: 'itemIncomeTotal',
						label: this.$t('money.incomeUzsTotal'),
						'class': 'td-30',
						visible: true,
						changebale: true
					},

				],
			}
		},
		computed: {
			...mapState(['userDepCurrencyName']),

			computedDepCurrencyName() {
				return this.userDepCurrencyName;
			},
		},
		methods: {

			async getAllDocuments() {

			},
			async save() {
				if( this.toDepartmentId){
					let sendData = {};
					sendData.documentId = this.currentDocument.id;
					sendData.toDepId = this.toDepartmentId;
					sendData.reason = this.reason;
					this.loading = true;
					await WhDocument.saveDocumentForTransfer(sendData).then(response => {

					}).catch(error => {
						this.$vs.notify({
							title: "Ошибка на сервере",
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
					});
					this.loading = false;


				}else{
					this.$vs.notify({
						title: "Выберите Отдел (Получатель)",
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}

			},

			closeModal() {
				this.modalTransfer = false;
			},
			openModalTransfer(data) {
				this.currentDocument  = data
				this.getDocumentById(data.id);
				this.modalTransfer = true;
			},
			async getDepartments() {
				await UsersService.getPermittedDepartments().then(response => {
					//this.dropdowns.department = response.data.permittedDepartments
					const departments = [];
					response.data.transferPermittedDepartments.map(item => {
						departments.push({
							value: item.id,
							text: `${item.name} - ${item.parentName ? item.parentName : ''}`,
							saleType: item.saleType
						});
					});

					this.toDepartments = departments
				});

			},
			async getDocumentById(id){
				await WhDocument.byDocument(id).then(response => {
					this.documentItems = response.data
				});
			},
			async getItems(){
				await WhDocument.getDocumentForTransaction().then(response => {
					this.items = response.data
				});
			}
		},
		created() {
			this.getAllDocuments();
			this.getDepartments();
			this.getItems();
		}
	}
</script>

<style>

</style>
